"use client";
import React, { useState } from "react";
import Banner from "@/components/Banner";
import UserFormModal from "@/components/UserFormModal";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ChevronRight } from "lucide-react";
import Image from "next/image";

const DOWNLOAD_URL =
  "https://cdn.msu.edu.in/pdf/Academic-Calender-2025-26.pdf";

const REDIRECT_URL =
  "https://application.msu.edu.in/campus-programme-registration";

const AcademicCalendar = () => {
  const [open, setOpen] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);

  const breadcrumbItems = [
    { label: "Academic Calendar"},
  ];

  // 🔽 Triggered after form success
  const handleFormSuccess = async () => {
    if (!shouldDownload) return;

    try {
      const response = await fetch(DOWNLOAD_URL);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Academic-Calendar-2025-26.pdf";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Redirect after download
      //   window.location.replace(REDIRECT_URL);
    } catch (error) {
      console.error("Download failed", error);
      window.location.replace(REDIRECT_URL);
    } finally {
      setShouldDownload(false);
      setOpen(false);
    }
  };

  return (
    <>
      {/* 🔐 Lead Capture Form */}
      <UserFormModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onSuccess={handleFormSuccess}
      />

      <Banner
        BannerImage="https://cdn.msu.edu.in/banners/ADP_7676+(1).webp"
        banner_bredcrumb_name="Academic Calendar"
        banner_name="Academic Calendar 2025-26"
        banner_tag_line="Plan your academic journey with MSU"
      />
      <Breadcrumbs items={breadcrumbItems} />

      <section className="w-full mx-auto block md:flex justify-center">
        <div className="max-w-(--max-page-width) px-(--container-padding) top_bottom_space">
          <div className="grid grid-cols-1 w-full gap-10">
            <div className="flex flex-col items-center">
              <div className="relative h-auto border border-gray-300 overflow-hidden">
                <Image
                  src="https://cdn.msu.edu.in/website-images/prospectus-2026.webp"
                  alt="Academic Calendar 2025-26"
                  width={1000}
                  height={1000}
                  className="
                    relative w-full max-w-[500px]
                    h-[320px]
                    sm:h-[380px]
                    md:h-[480px]
                    lg:h-[520px]
                    border border-gray-300
                  "
                />
              </div>

              {/* ✅ DOWNLOAD BUTTON */}
              <button
                onClick={() => {
                  setShouldDownload(true);
                  setOpen(true);
                }}
                className="cursor-pointer mt-6 md:mt-8 text-[#E09512] flex items-center justify-center gap-2"
              >
                <span className="font-semibold text-xl md:text-2xl tracking-wide">
                  DOWNLOAD
                </span>
                <span
                  className="bg-[#00304b] rounded-full p-2 md:p-3 shadow hover:bg-black transition-colors"
                  aria-label="Download Academic Calendar 2025-26"
                >
                  <ChevronRight className="w-4 md:w-5 h-4 md:h-5 text-white" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcademicCalendar;
